import * as ScoreType from 'constants/ScoreType';
import * as GroupType from 'constants/GroupType';
import * as Period from 'constants/Period';

const BIATHLON_SCORE_MAP = {};
BIATHLON_SCORE_MAP[Period.NOT_STARTED] = {
    [GroupType.DEFAULT_GROUP]: {
        main: ScoreType.Match,
        additional: [
            ScoreType.FirstPeriod,
            ScoreType.SecondPeriod,
            ScoreType.ThirdPeriod,
            ScoreType.FourthPeriod,
            ScoreType.FifthPeriod,
            ScoreType.SixthPeriod,
            ScoreType.SeventhPeriod,
            ScoreType.EighthPeriod
        ]
    },
    [GroupType.FIRST_PERIOD_GROUP]: {
        main: ScoreType.FirstPeriod
    },
    [GroupType.SECOND_PERIOD_GROUP]: {
        main: ScoreType.SecondPeriod
    },
    [GroupType.THIRD_PERIOD_GROUP]: {
        main: ScoreType.ThirdPeriod
    },
    [GroupType.FOURTH_PERIOD_GROUP]: {
        main: ScoreType.FourthPeriod
    },
    [GroupType.FIFTH_PERIOD_GROUP]: {
        main: ScoreType.FifthPeriod
    },
    [GroupType.SIXTH_PERIOD_GROUP]: {
        main: ScoreType.SixthPeriod
    },
    [GroupType.SEVENTH_PERIOD_GROUP]: {
        main: ScoreType.SeventhPeriod
    },
    [GroupType.EIGHTH_PERIOD_GROUP]: {
        main: ScoreType.EighthPeriod
    }
};

export default BIATHLON_SCORE_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Biathlon/ScoreMap.js